<ng-template [ngIf]="!loading">      
    <div class="content-inner">
        <form [formGroup]="enterUOSReasonForm" *ngIf="!loadingRecords">
            <div *ngFor="let block of shiftBlocks" class="shift-block workflow-input">
                <label for="{{ getShiftBlockControlName(block.id) }}">{{ getShiftBlockLabel(block) }}</label>
                <smt-enter-reason-uos-block #EnterReasonUosEditForm 
                    [shiftRecord]="getShiftRecordByShiftBlockId(block.id)"
                    [enterReasonForm]="enterUOSReasonForm"
                    [enterByBlock]="ancillaryConfiguration.enterUOSByBlock">
                </smt-enter-reason-uos-block>    
                <br>            
            </div>
        </form>       
        <div *ngIf="!loadingRecords && !hasShiftBlocks() && ancillaryConfiguration.enterUOSByBlock" class="no-previous-block">This cost center has no previous shift block.  Please proceed to the next page.</div>
        <div *ngIf="!loadingRecords && !hasShiftBlocks() && !ancillaryConfiguration.enterUOSByBlock" class="no-previous-block">This cost center has no previous working day.  Please proceed to the next page.</div>
        <div class="loading" *ngIf="loadingRecords"></div>
    </div>
</ng-template>